module.exports = __webpack_public_path__ + "img/Header_SocialGames.6252d77a.png";